import { IS_DEV } from "@config/consts";

if (IS_DEV && process.env.ENABLE_DETECT_RERENDER === "true") {
  const React = require("react");
  const whyDidYouRender = require("@welldone-software/why-did-you-render");
  const ReactRedux = require("react-redux/lib");

  const { useAuth } = require("@hooks/useAuth");
  const { useLocalisation } = require("@hooks/useLocalisation");
  const { useTranslate } = require("@hooks/useTranslate");
  const { useBreakpoint } = require("@hooks/useBreakpoint");
  const { useFeatureToggle } = require("@hooks/useFeatureToggle");
  const { usePrismic } = require("@hooks/usePrismic");
  const { useModalManager } = require("@hooks/modal");

  whyDidYouRender(React, {
    trackAllPureComponents: true,
    trackExtraHooks: [
      [ReactRedux, "useSelector"],
      [useAuth, "useAuth"],
      [useLocalisation, "useLocalisation"],
      [useTranslate, "useTranslate"],
      [useBreakpoint, "useBreakpoint"],
      [useFeatureToggle, "useFeatureToggle"],
      [usePrismic, "usePrismic"],
      [useModalManager, "useModalManager"],
    ],
    titleColor: "green",
    diffNameColor: "darkturquoise",
  });
}
